import React from 'react';
import { Field, FastField, FieldProps } from 'formik';

import { useRegisteredRef } from 'src/lib/react-register-nodes';
import { MultiCombobox, MultiComboboxProps } from 'src/kit';
import { FormikErrorMessage } from '../FormikErrorMessage';

export type FormikMultiComboboxProps = MultiComboboxProps & { name: string; isFast?: boolean };

export const FormikMultiCombobox = ({
  isFast,
  name,
  value,
  onChange,
  onSelect,
  onRemove,
  ...rest
}: FormikMultiComboboxProps) => {
  const FieldComponent = isFast ? FastField : Field;
  const ref = useRegisteredRef(name);

  return (
    <FieldComponent name={name}>
      {({ field, form: { setFieldValue, setFieldTouched }, meta: { touched, error } }: FieldProps) => {
        const formikError = touched && typeof error === 'string' && error;
        const handlers =
          onSelect && onRemove
            ? { onSelect, onRemove }
            : {
                onChange: v => {
                  setFieldValue(name, v).then(() => {
                    if (!touched) {
                      setFieldTouched(name, true, false);
                    }
                  });
                  if (onChange) {
                    onChange(v);
                  }
                }
              };

        return (
          <MultiCombobox
            ref={error ? ref : undefined}
            value={value || field.value}
            onBlur={() => {
              setFieldTouched(name, true);
            }}
            name={name}
            error={formikError}
            {...handlers}
            {...rest}
          >
            {formikError && <FormikErrorMessage name={name} />}
          </MultiCombobox>
        );
      }}
    </FieldComponent>
  );
};
